import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01284dff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Rate card")
], -1))
const _hoisted_3 = { class: "col-sm-6 text-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No ratecards found", -1))
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "col-md-11 table table-bordered" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Inventory (£)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Check-In (£)", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, "Check-Out (£)", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "align-middle" }, " Inventory Check-In or b2b CO&CI (£) ", -1))
const _hoisted_14 = { class: "align-middle" }
const _hoisted_15 = { class: "align-middle" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "align-middle" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "align-middle" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "align-middle" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "col-md-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))

import { ref,inject, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import ContentEditable from '@/components/ContentEditable.vue';
import { Inspector, RateCard, PiRate } from '@/models';

export default /*#__PURE__*/_defineComponent({
  __name: 'RateCard',
  setup(__props) {

const store = useStore();

// Define refs and reactive properties
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const inspector = computed(() =>  store.getters['inspectors/current']);

// Define actions
const addRateCard = async (ratecard: RateCard): Promise<RateCard> => {
  return await store.dispatch('inspectors/addRateCard', ratecard);
};

const removeRateCard = async (ratecard: RateCard): Promise<RateCard> => {
  return await store.dispatch('inspectors/removeRateCard', ratecard);
};

const setInspectorDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('inspectors/setInspectorDeep', payload);
};
const actProperty: any = inject('actProperty');
const toasted = useToast();

const furnishedOptions = ref<string[]>([
  "Unfurnished",
  "Part furnished",
  "Fully furnished",
  "Fully furnished with linen",
]);

const propertySizeOptions = ref<string[]>([
  "Studio",
  "1 Bedroom",
  "2 Bedroom",
  "3 Bedroom",
  "4 Bedroom",
  "5 Bedroom",
  "6 Bedroom +",
]);
const addNewRateCard = () => {
  const filteredFurnishedList = furnishedOptions.value.filter((f) => {
    const index = store.state.inspectors.current.ratecards.findIndex(
      (r: RateCard) => r.furnishedtype === f
    );
    return index < 0;
  });

  if (filteredFurnishedList && filteredFurnishedList.length) {
    const newratecard = new RateCard({
      furnishedtype: filteredFurnishedList[0],
    });
    newratecard.rates = propertySizeOptions.value.map(
      (s) => new PiRate({ propertysize: s })
    );
    addRateCard(newratecard);
  } else {
    // Use your own logic to display an error message
    console.error("All furnished types have rate cards!");
  }
};

const _delete = (ratecard: RateCard) => {
  const confirm = actProperty.confirmPrompt(
    "Are you sure you want to delete this rate card?"
  );

  confirm
    .then(() => removeRateCard(ratecard))
    .then(() => toasted.success(`Deleted`))
    .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-lg btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewRateCard()))
          }, [
            _hoisted_4,
            _createTextVNode(" New Ratecard ")
          ])
        ])
      ])
    ]),
    (!inspector.value.ratecards.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, "for " + _toDisplayString(inspector.value.name) + ", please add", 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspector.value.ratecards, (ratecard, $ratecardindex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: $ratecardindex,
        class: "row"
      }, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_9, [
                _createVNode(_component_multiselect_text, {
                  modelValue: ratecard.furnishedtype,
                  "onUpdate:modelValue": ($event: any) => ((ratecard.furnishedtype) = $event),
                  value: ratecard.furnishedtype,
                  options: furnishedOptions.value,
                  class: "noborder"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "options"])
              ]),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ratecard.rates, (pirate, $pirateindex) => {
              return (_openBlock(), _createElementBlock("tr", { key: $pirateindex }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(pirate.propertysize), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(ContentEditable, {
                    content: pirate.inventory,
                    decimal: true,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    onUpdate: ($event: any) => (
                setInspectorDeep({
                  path: `ratecards[${$ratecardindex}].rates[${$pirateindex}].inventory`,
                  data: $event,
                })
                )
                  }, null, 8, ["content", "onUpdate"]),
                  (pirate.propertysize === '6 Bedroom +')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Extra per bedroom "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(ContentEditable, {
                    content: pirate.ci,
                    decimal: true,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    onUpdate: ($event: any) => (
                setInspectorDeep({
                  path: `ratecards[${$ratecardindex}].rates[${$pirateindex}].ci`,
                  data: $event,
                })
                )
                  }, null, 8, ["content", "onUpdate"]),
                  (pirate.propertysize === '6 Bedroom +')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Extra per bedroom "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createVNode(ContentEditable, {
                    content: pirate.co,
                    decimal: true,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                    onUpdate: ($event: any) => (
                setInspectorDeep({
                  path: `ratecards[${$ratecardindex}].rates[${$pirateindex}].co`,
                  data: $event,
                })
                )
                  }, null, 8, ["content", "onUpdate"]),
                  (pirate.propertysize === '6 Bedroom +')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Extra per bedroom "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createVNode(ContentEditable, {
                    content: pirate.combo,
                    decimal: true,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                    onUpdate: ($event: any) => (
                setInspectorDeep({
                  path: `ratecards[${$ratecardindex}].rates[${$pirateindex}].combo`,
                  data: $event,
                })
                )
                  }, null, 8, ["content", "onUpdate"]),
                  (pirate.propertysize === '6 Bedroom +')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Extra per bedroom "))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn btn-outline-danger",
            onClick: [
              ($event: any) => (_delete(ratecard)),
              _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            ]
          }, [
            _hoisted_25,
            _createTextVNode(" Delete ")
          ], 8, _hoisted_24)
        ])
      ]))
    }), 128))
  ]))
}
}

})